import { Route, Routes } from 'react-router-dom';
import './App.css';
import CustomerRoutes from './Routers/CustomerRoutes';
import ScrollToTop from './customer/Components/ScrollTop';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { loadUserFromToken } from './Redux/Auth/Action'; 
// import ChatWidget from './customer/Components/ChatAi/ChatWidget';
import { ThemeProvider } from './contexts/ThemeContext';
import WhatsAppButton from './customer/Components/WhatsAppButton/WhatsAppButton';

function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(loadUserFromToken()); 
  }, [dispatch]);

  useEffect(() => {
    console.log("Website Designed & Developed by Aryesh Shivmare\nhttps://aryesh.in/");
  }, []);

  return (
    <ThemeProvider>
      <ScrollToTop />
      <Routes>
        <Route path="/*" element={<CustomerRoutes />} />
      </Routes>
      {/* <ChatWidget /> */}
      <WhatsAppButton />
    </ThemeProvider>
  );
}
export default App;